export const GET_ACTIVE_TRANSACTION_PRICING_OFFER = gql`
    query getActiveTransactionPricingOffers {
        getActiveTransactionPricingOffers {
            id
            offerName
            revenueShare
            additionalTariffCharges {
                id
                name
                type
                baseRate
                lowestRate
                highestRate
                fixedRate
            }
            compliancePricingCharges {
                id
                name
                type
                chargeType
                baseRate
                lowestRate
                highestRate
                fixedRate
            }
            transactionPricingCards {
                id
                name
                type
                cardCategory
                baseRate
                percentageBaseRate
                percentageLowestRate
                percentageHighestRate
                percentageHighestRate
                perItemBaseRate
                perItemLowestRate
                perItemHighestRate
                baseRatePercentage
            }
            offers {
                id
                name
                term
                customTerm
                type
                status
            }
            partners {
                id
                firstName
                lastName
            }
        }
    }
`;

// Using a separate query for partner related offers to not impact calls for all tx pricing offers
export const GET_ACTIVE_TRANSACTION_PRICING_OFFER_FOR_PARTNER = gql`
    query getActiveTransactionPricingOffersForPartner($partnerId: Int) {
        getActiveTransactionPricingOffersForPartner(partnerId: $partnerId) {
            id
            offerName
            revenueShare
            additionalTariffCharges {
                id
                name
                type
                baseRate
                lowestRate
                highestRate
                fixedRate
            }
            compliancePricingCharges {
                id
                name
                type
                chargeType
                baseRate
                lowestRate
                highestRate
                fixedRate
            }
            transactionPricingCards {
                id
                name
                type
                cardCategory
                baseRate
                percentageBaseRate
                percentageLowestRate
                percentageHighestRate
                percentageHighestRate
                perItemBaseRate
                perItemLowestRate
                perItemHighestRate
                baseRatePercentage
            }
            offers {
                id
                name
                term
                customTerm
                type
                status
            }
            partners {
                id
                firstName
                lastName
            }
        }
    }
`;
